import axios from "axios";

import { BASE_URL } from "src/utils/constants";

export function LoginWithGoogle(_data) {
  const data = {
    gid: _data.googleID,
    emailId: _data.email,
    name: _data.name,
    deviceToken: "",
    deviceType: "web",
    isLogin: "",
    appname: "eventmoon",
    isTermsChecked: "true",
    Country: "",
    State: "",
    City: "",
  };

  const response = axios({
    method: "POST",
    url: `${BASE_URL()}/LoginGoogle`,
    data: data,
    headers: { "Content-Type": "application/json" },
  });

  return response;
}
